import { Component, OnInit, HostListener } from '@angular/core';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html'
})
export class WelcomeComponent implements OnInit {
  OnSideMenuClick: boolean;
  divWidth: number;
  clickOnProfile: boolean = false;

  // Host listener on window resize
  @HostListener('window:resize', ['$event'])
  onResize() {
    localStorage.setItem('WindowHeight', window.innerHeight.toString());
    localStorage.setItem('WindowWidth', window.innerWidth.toString());
  }
  // listen on Mouse click event
  @HostListener('mousedown', ['$event'])
  onmousedown(event) {
    const target = event.target || event.srcElement || event.currentTarget;
    if (target) {
      const idAttr = target.attributes.id;
      if (idAttr) {
        const nodevalue = idAttr.nodeValue;
        if (nodevalue && (nodevalue == 'idProfile' || nodevalue == 'idLogout')) {
          if (nodevalue == 'idProfile') {
            this.OnProfileClick();
          }
        }
        else {
          this.clickOnProfile = false;
        }
      }
      else {
        this.clickOnProfile = false;
      }
    }
    else {
      this.clickOnProfile = false;
    }
  }

  constructor() { }

  ngOnInit(): void {
    this.onResize();
    const sideMenuclicked = localStorage.getItem('Toggled');

    if (sideMenuclicked && sideMenuclicked == 'Y') {
      this.OnSideMenuClick = false;
      this.divWidth = window.innerWidth - 240;
    }
  }
  // call on select side menu for toggle
  onselected(event) {
    this.OnSideMenuClick = !event;
    localStorage.setItem('Toggled', this.OnSideMenuClick === false ? 'Y' : 'N');

    if (this.OnSideMenuClick == false) {
      this.divWidth = window.innerWidth - 240;
    }
  }

  // On click profile icon
  OnProfileClick() {
    this.clickOnProfile = !this.clickOnProfile;
  }
}
